import React from "react";
import { Ellipse, Group, Rect } from "react-konva";
import type { DynamicFurnitureShape as DynamicShape } from "../../../../types";
import { layoutDynamicTable } from "../../../../utils/dynamicFurniture";
import type { ShapeCommonProps } from "../../types";
import { useShape } from "../ShapeContext/useShape";

export { DynamicFurnitureSVG, DynamicTableSVG } from "./DynamicFurnitureSVG";

export const DynamicFurnitureShape = React.forwardRef<
  React.ComponentRef<typeof Group>,
  ShapeCommonProps
>((props, ref) => {
  const { shape: raw } = useShape();
  const shape = raw as DynamicShape;
  const g = layoutDynamicTable(shape.layout);
  const color = shape.color || "#E8ECEF";
  return (
    <Group {...props} ref={ref} width={shape.width} height={shape.height}>
      <Group scaleX={shape.width / g.width} scaleY={shape.height / g.height}>
        {g.parts.map((p) =>
          p.ellipse ? (
            <Ellipse
              key={p.key}
              x={p.x + p.width / 2}
              y={p.y + p.height / 2}
              radiusX={p.width / 2}
              radiusY={p.height / 2}
              fill={color}
              stroke="#9CA3AF"
              strokeWidth={1}
              perfectDrawEnabled={false}
            />
          ) : (
            <Rect
              key={p.key}
              x={p.x}
              y={p.y}
              width={p.width}
              height={p.height}
              rotation={p.rotation}
              cornerRadius={p.radius}
              fill={
                p.kind === "chair-back" || p.kind === "chair-arm"
                  ? "#D1D5D9"
                  : color
              }
              stroke="#9CA3AF"
              strokeWidth={1}
              perfectDrawEnabled={false}
            />
          )
        )}
      </Group>
    </Group>
  );
});
DynamicFurnitureShape.displayName = "DynamicFurnitureShape";
